export default __webpack_public_path__ + "static/leftDots-84ccc7bda2517b624004ef65604d6c9c.png";